import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Tooltip,
  TableHead,
  TableRow,
  Input,
  TablePagination,
  Typography,
  IconButton,
  Button,
  Stack,
  Box,
} from "@mui/material";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import { fetchAuthSession } from "@aws-amplify/core";
import { tlmPostPinDeviceNote } from "layouts/dashboard/apiService";
import { DeviceNotesColumns } from "./columns";
import { AddNewDeviceNoteDialog } from "popup/AddNewDeviceNoteDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import Skeleton from "@mui/material/Skeleton";
import { tlmDeleteDeviceNote } from "layouts/dashboard/apiService";
import NoData from "components/NoData";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import AddIcon from "@mui/icons-material/Add"; // Import dell'icona Add
import {
  tlmPostPinPlantNote,
  tlmGetDeviceNote,
} from "layouts/dashboard/apiService";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "@aws-amplify/core";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useRefresh } from "layouts/dashboard/RefreshContext";
export const RenderDeviceNote = ({
  devicePlantState,
  resourcePrefPageDev,
  rowsPerResourcePrefPageDev,
  setResourcePrefPageDev,
  setRowsPerResourcePrefPageDev,
  account_number,
  endDate,
  startDate,
  dispatchDevicePlant,
  setStartDate,
  setEndDate,
  profile,
  language,
}) => {
  const formatTimestamp = (timestamp) =>
    dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss");
  const isGuest = profile && profile.includes("Guest"); // Check if profile includes "Guest"
  const isOperator = profile && profile.includes("Operator");
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  //const isGuest = profile && profile.includes("Guest"); // Check if profile includes "Guest"
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const toolbarRef = useRef(null);
  const [userInfo, setUserInfo] = useState({
    email: "",
    name: "",
    profiles: ["NOT ADMIN"],
  });
  const { handleRefresh } = useRefresh();
  const tlmGetUserGroups = async (userID) => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/userManagement/user/groups",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: { user_id: userID },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      // Extract profiles from the response and set groupNameSel with the first profile
      const profiles = response.profiles.map((profile) => profile.group_name);
      return profiles;
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  };
  useEffect(() => {
    async function currentSession() {
      try {
        const { accessToken, idToken } =
          (await fetchAuthSession()).tokens ?? {};
        const profiles = await tlmGetUserGroups(
          idToken.payload["cognito:username"]
        );

        setUserInfo({
          name: idToken.payload.name || "No Name",
          email: idToken.payload.email || "No email",
          profiles: profiles || [],
        });

        // Save profiles to setProfile
      } catch (err) {}
    }

    currentSession();
  }, []);
 
  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const plantNotesColumns = DeviceNotesColumns();

  const normalizeEmail = (email) =>
    email
      .normalize("NFKC")
      .replace(/\u200B|\uFEFF/g, "")
      .replace(/[\u2010-\u2015\u2212\uFE63\uFF0D]/g, "-")
      .trim()
      .toLowerCase();
  const handlePinClick = async (noteID, currentPinnedValue) => {
    const newPinnedValue = !currentPinnedValue;
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Pinning"),
      });
      const restOperation = await tlmPostPinDeviceNote(noteID, newPinnedValue);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Pinned successfully"),
        });
        const plantNoteResponse = await tlmGetDeviceNote(
          account_number,
          endDate,
          startDate
        );
        dispatchDevicePlant({
          type: "DATA_RECEIVED",
          value: plantNoteResponse,
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error Pinned"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error Pinned"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  const handleDeleteNote = async (noteID) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Deleting device note"),
      });
      const restOperation = await tlmDeleteDeviceNote(noteID);

      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Device Note deleted successfully"),
        });

        const notesResponse = await tlmGetDeviceNote(
          account_number,
          endDate,
          startDate
        );
        dispatchDevicePlant({ type: "DATA_RECEIVED", value: notesResponse });
      } else if (response.statusCode === 401) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Unauthorized user"),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error deleting device note"),
        });
      }

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error deleting device note"),
      });

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  if (!devicePlantState.data || devicePlantState.data.length === 0) {
    return (
      <Card sx={{ marginBottom: "1rem" }}>
        <CardContent
          sx={{ padding: "1rem", "&:last-child": { padding: "1rem 0" } }}
        >
          <Stack
            spacing={2}
            direction={tableParentIsMD ? "column" : "row"}
            alignItems="center"
            sx={{ pb: 2 }}
          >
            {/* Add New Device Note button with tooltip. Button opens Add Dialog when clicked 
    <Tooltip title="Add New Device Note">
      <IconButton 
        onClick={() => setOpenAddDialog(true)} 
        disabled={isGuest} // Disable button if user is a guest
      >
        <AddIcon />
      </IconButton>
    </Tooltip>
     End of Add New Device Note button */}

            {/* No Data message */}
            <Box
              sx={{
                ml: 2,
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography variant="h5">{I18n.get("Device Note")}</Typography>
            </Box>
          </Stack>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NoData />
          </Box>
        </CardContent>
        <AddNewDeviceNoteDialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          accountNumber={account_number}
          dispatchDevicePlant={dispatchDevicePlant}
          startDate={startDate}
          endDate={endDate}
        />

        {/* API Status Dialog */}
        <APIStatusDialog
          open={apiStatus.open}
          status={apiStatus.status}
          message={apiStatus.message}
        />
      </Card>
    );
  }

  return (
    <Card sx={{ marginBottom: "1rem" }}>
      <CardContent
        sx={{ padding: "1rem", "&:last-child": { padding: "1rem 0" } }}
      >
        <Stack
          spacing={2}
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          sx={{ pb: 2 }}
        >
          {/* Add New Device Note button with tooltip. Button opens Add Dialog when clicked 
    <Tooltip title="Add New Device Note">
      <IconButton 
        onClick={() => setOpenAddDialog(true)} 
        disabled={isGuest} // Disable button if user is a guest
      >
        <AddIcon />
      </IconButton>
    </Tooltip>
     End of Add New Device Note button */}

          <Box
            sx={{
              ml: 2,
              flexGrow: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography variant="h5">
              {" "}
              {/* Added margin-left auto to push it to the right */}
              {I18n.get("Device Note")}
            </Typography>
          </Box>
        </Stack>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {plantNotesColumns.map((column) => (
                  <TableCell key={column.id}>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {devicePlantState.data
                .slice(
                  resourcePrefPageDev * rowsPerResourcePrefPageDev,
                  resourcePrefPageDev * rowsPerResourcePrefPageDev +
                    rowsPerResourcePrefPageDev
                )
                .map((mappingRow, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {plantNotesColumns.map((column, colIndex) => (
                      <TableCell key={colIndex} sx={{ padding: "0px" }}>
                        {column.id === "timestamp" ? (
                          formatTimestamp(mappingRow[column.id]) // Formattazione qui
                        ) : column.id === "pinned" ? (
                          // Colonna "pinned" con il pulsante per gestire il pin
                          <IconButton
                            onClick={() =>
                              handlePinClick(mappingRow.id, mappingRow.pinned)
                            }
                            disabled={
                              isGuest
                              // || normalizeEmail(userInfo.email) !==
                              //   normalizeEmail(mappingRow.executor)
                            } // Disabilitato per utenti non autorizzati
                          >
                            {mappingRow.pinned ? (
                              <PushPinIcon />
                            ) : (
                              <PushPinOutlinedIcon />
                            )}
                          </IconButton>
                        ) : column.id === "action" ? (
                          // Colonna "action" con il pulsante di eliminazione
                          <Tooltip
                            title={
                              isGuest ||
                              ( isOperator && normalizeEmail(userInfo.email) !==
                                normalizeEmail(mappingRow.executor))
                                ? I18n.get("Unauthorized User")
                                : ""
                            }
                            arrow
                          >
                            <span>
                              <IconButton
                                onClick={() => handleDeleteNote(mappingRow.id)}
                                disabled={
                                  isGuest ||
                                  ( isOperator && normalizeEmail(userInfo.email) !==
                                    normalizeEmail(mappingRow.executor))
                                } // Disabilitato per utenti non autorizzati
                              >
                                <DeleteIcon /> {/* Icona di eliminazione */}
                              </IconButton>
                            </span>
                          </Tooltip>
                        ) : mappingRow[column.id] !== undefined &&
                          mappingRow[column.id] !== null ? (
                          mappingRow[column.id]
                        ) : (
                          ""
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={devicePlantState.data.length}
          page={resourcePrefPageDev}
          onPageChange={(event, newPage) => setResourcePrefPageDev(newPage)}
          rowsPerPage={rowsPerResourcePrefPageDev}
          onRowsPerPageChange={(event) => {
            setRowsPerResourcePrefPageDev(parseInt(event.target.value, 10));
            setResourcePrefPageDev(0);
          }}
          rowsPerPageOptions={[]}
        />
      </CardContent>

      {/* Dialogo per lo stato dell'API */}
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
      <AddNewDeviceNoteDialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        accountNumber={account_number}
        dispatchDevicePlant={dispatchDevicePlant}
        startDate={startDate}
        endDate={endDate}
      />
    </Card>
  );
};
